import {View} from 'react-native';
import sy from '~/styles';
import {Text, Pressable, RadioButton} from '~/components/controls';
const INVOICE_REASONS = [
  ['WillNotBeInvoicedForWarrantyOrLeniencyReasons', 'Garantie of coulance'],
  ['Invoiced', 'Al gefactureerd'],
  ['WillNotBeInvoiced', 'Niet gefactureerd'],
];
const InvoiceReasons = ({invoiceStatus, setInvoiceStatus}) => (
  <View>
    {INVOICE_REASONS.map(([value, label]) => (
      <Pressable
        key={value}
        style={[sy['flex-row']]}
        onPress={() => setInvoiceStatus(value)}>
        <View style={[sy['p-4'], sy['pr-8']]}>
          <RadioButton checked={invoiceStatus === value} />
        </View>
        <View
          style={[
            sy['flex-row'],
            sy['flex-1'],
            sy['justify-between'],
            sy['py-4'],
            sy['pr-4'],
            sy['border-b'],
            sy['border-lightgray'],
          ]}>
          <Text>{label}</Text>
        </View>
      </Pressable>
    ))}
  </View>
);
export default InvoiceReasons;
